import { GlobalState } from "../global.store";

export const selectAuth = (state: GlobalState) => {
  return state.auth;
};
